<form id="login-form" [formGroup]="form">
  <div class="logo"><img src="assets/svg/LogoDiadem.svg" alt="logo-diadem"></div>
  <mat-form-field appearance="outline" class="w-full mb-3">
    <mat-label>{{'USERNAME'|translate}}</mat-label>
    <input matInput formControlName="username" [ngClass]="{ 'is-invalid': controls.username.errors }" />
    @if (controls.username.errors) {
      <mat-error> {{'INVALID_USERNAME'|translate}} </mat-error>
    }
  </mat-form-field>
  <mat-form-field appearance="outline" class="w-full mb-3">
    <mat-label>{{'PASSWORD'|translate}}</mat-label>
    <input matInput type="password" formControlName="password" [ngClass]="{ 'is-invalid': controls.password.errors }" />
    @if (controls.password.errors) {
      <mat-error> {{'INVALID_PASSWORD'|translate}} </mat-error>
    }
  </mat-form-field>
  <a class="text-tw-primary w-fit cursor-pointer hover:text-tw-dark-primary" (click)="onForgotPassword()">
    <div class="flex gap-2 items-center">
      <mat-icon>lock_reset</mat-icon>
      <span>{{'FORGOT_PASSWORD' | translate}}</span>
    </div>
  </a>
  <div class="btn-container text-right">
    <button mat-flat-button class="bg-tw-primary text-tw-text-light" [disabled]="isDisabled() || isLoading" color="primary" type="button" (click)="onSubmit()"> {{'CONNECTION'|translate}} </button>
  </div>
</form>